import type { MessageDto, TicketDetailDto } from "@megaron/support-contracts";

import { isSupportTicketFromEmailMailbox } from "./supportTicketMessagesSectionTitle";

export function shouldRenderSupportTicketFormEntry(ticket: TicketDetailDto, message: MessageDto): boolean {
  return !message.fromAgent && !isSupportTicketFromEmailMailbox(ticket);
}
